import ClayLayout from "@clayui/layout";
import { useEffect, useState } from "react";
import "../../index.scss";
import { getCoursesAndFirstLessons } from "../../services/course";
import { RELATIONSHIP, RELATIONSHIP_NAME, OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";
import SectionCard from "../Common/SectionCard";

const CoursesList = ({ type }) => {
	const [courses, setCourses] = useState(null);

	useEffect(() => {
		const fetchCourses = async () => {
			const data = await getCoursesAndFirstLessons();

			const moduleCourse = RELATIONSHIP_NAME.COURSES_IN_MODULES;

			const baseFilter = (course) =>
				course[RELATIONSHIP.MODULES_TO_LESSONS]?.[0]?.friendlyUrlPath &&
				course[moduleCourse];
	
			const audienceFilter = (course) =>
				course[moduleCourse].audience?.some((a) => a.key === type);
	
			const filteredCourses =
				type === "sales"
					? data.filter((course) => baseFilter(course) && audienceFilter(course))
					: data.filter(baseFilter);
	
			const sortedCourses = filteredCourses.sort(
				(a, b) =>
					a[moduleCourse].position - b[moduleCourse].position
			);
	
			setCourses(sortedCourses.slice(0, 3));
		};
	
		fetchCourses();
	}, [type]);

	return (
		<ClayLayout.ContainerFluid view>
			<ClayLayout.Row justify="start" className="flex-column-custom">
				{courses && courses.length > 0 && (
					<>
						{courses.map((course, index) => {
							const moduleCourse = course[RELATIONSHIP_NAME.COURSES_IN_MODULES];
	
							return (
								<SectionCard
									description={!moduleCourse.description ? "" : moduleCourse.description}
									duration={moduleCourse.durationMinutes}
									expertise={moduleCourse.expertiseLevel.name}
									index={index}
									key={moduleCourse.id}
									link={`/${OBJECT_ENTRY_URL_SEPARATOR.LESSON}/${course[RELATIONSHIP.MODULES_TO_LESSONS][0].friendlyUrlPath}`}
									personas={moduleCourse.audience}
									title={!moduleCourse.title ? "" : moduleCourse.title}
									type={type}
								/>
							);
						})}
					</>
				)}
			</ClayLayout.Row>
		</ClayLayout.ContainerFluid>
	);
};

export default CoursesList;
